'use client';

import classNames from 'classnames';
import useFeedbackModalStore from './store';

export default function ButtonCTA({
  children,
  className,
  subject,
  onClick
}: {
  subject?: string | null;
  className?: string;
  onClick?: () => void;
} & React.PropsWithChildren) {
  const { open, setSubject } = useFeedbackModalStore();

  return (
    <button
      type="button"
      className={classNames(className)}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        open();
        onClick?.call(null);
        setSubject(subject || '');
        console.log(subject);
      }}
    >
      {children}
    </button>
  );
}
